import $ from 'jquery';


export default () => {

    $('.page-template-template-aree .nav-pills a.nav-link').on('click', function (e) {
        e = e || window.event;
        e.preventDefault();

        $('html, body').animate({scrollTop: $('#dettaglio-area-comune').offset().top - 100}, 500, 'linear');
    });

};



// WEBPACK FOOTER //
// ./scripts/libs/aree.js